<template>
<div>
  <div class="m_context">

		<p  v-show="tmcid" class='gCtColor gPTitle' style='height:25px;background:none;margin-top:-10px;margin-bottom:20px;'>{{$t('app_childacmg')}} </p>

<el-row :gutter="20" style="margin-bottom: 20px;">
  <el-col :span="4" style="padding-left: 24px;">
    <el-button type="primary" @click="add" >{{$t('lin_btn.add_zeng')}}</el-button>
  </el-col>


	

  <el-col :span="4" :offset="tmcid?12:8">
    <el-select style='width:100%;' v-model="roleId" @change="roleChange" :placeholder="$t('lin_global.roles_tips')">
      <el-option
        v-for="item in roleList"
		:key="item.roleid"
        :label="item.rolename"
        :value="item.roleid">
      </el-option>
    </el-select>
  </el-col>

	<el-col :span="4" v-show='!tmcid'>
    <!--<el-select v-model="value2" @change="statusChange" :placeholder="$t('lin_global.pselect')">-->
      <!--<el-option v-for="item in areaList1" :label="item.mechanismname" :value="item.mechanismid">-->
      <!--</el-option>-->
    <!--</el-select>-->
    <MechanismSelector style='width:100%;' :data="mechanismData" ></MechanismSelector>
  </el-col>
  
  <el-col :span="4" style="padding-right: 24px;">
    <el-input
      :placeholder="$t('lin_global.nickName') + ' / ' + $t('app_account')"
      icon="search"
      v-model="nickName"
      :on-icon-click="handleIconClick"
      @keyup.enter.native="focusEvent(handleIconClick)">
    </el-input>
  </el-col>


	        </el-row>
	<el-table
	  	:data="arrdata"
	  	border
	  	style="width:100%" 
	  	ref="arrdata"
			@sort-change='sortChange'
	  	v-loading="loading"
	  	:element-loading-text="$t('lin_global.loading')">
	  		<el-table-column
	  		prop="userName"
				sortable="custom"
        :label="$t('lin_global.userName')"
	  		width="150">
	  		</el-table-column>
	  		<el-table-column
	  		prop="nickName"
				sortable="custom"
        :label="$t('lin_global.nickName')"
	  		width="180">
	  		</el-table-column>
	  		<el-table-column
	  		prop="phoneNum"
        :label="$t('lin_global.phoneNum')"
	  		width="180">
	  		</el-table-column>
				<el-table-column
	  		prop="limitIp"
        :label="$t('app_allowiplg')"
	  		width="180">
	  		</el-table-column>
	  		<el-table-column
	  		prop="roleName"
        :label="$t('lin_global.roleName')"
	  		width="180">
	  		</el-table-column>
	  		<el-table-column
	  		prop="mechanismName"
        :label="$t('lin_global.label_areaid')">
	  		</el-table-column>
	  		<el-table-column
	  		prop="userStatus"
        :label="$t('lin_global.status')"
	  		width="100"
	  		:formatter="formatStatus">
	  		</el-table-column>

				<el-table-column
	  		prop="createTime"
				sortable="custom"
        :label="$t('app_addtime')">
	  		</el-table-column>

	  		<el-table-column
          :label="$t('lin_global.ope')"
        width="150">
				<template slot-scope="scope">
					<!-- <el-button @click.stop="editRow(scope.row.userid)" type="text">{{$t('lin_btn.edit')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.unbind')" placement="top" v-if="scope.row.bindMfa=='1'">
						<el-button type='text' @click.stop="unbindRow(scope.row)"><i class="fa fa-chain-broken" style=""></i></el-button>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="MFA" placement="top" v-else>
						<el-button type='text' @click.stop="bindRow(scope.row)"><i class="fa fa-chain" style=""></i></el-button>
					</el-tooltip>
					


					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.edit')" placement="top">
						<el-button type='text' @click.stop="editRow(scope.row.userid)"><i class="fa fa-pencil" style=""></i></el-button>
					</el-tooltip>

					<!-- <el-button @click.stop="deleteRow(scope.row.userid)" type="text">{{$t('lin_btn.delete')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.delete')" placement="top">
						<el-button type='text' @click.stop="deleteRow(scope.row.userid)"><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
					</el-tooltip>
				</template>
	  		</el-table-column>
	  	</el-table>
	  	<div class="page_content" v-if="totalRecords > 0">
		  <el-pagination style='float:right;'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="[10,50,100]"
		    :page-size="pageSize"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords">
		  </el-pagination>
		</div>

		<el-dialog
		cclass="gDia"
		@open="bindOpen"
		@close="closeBind"
		ttitle="$t('app_mulfcau')"
		v-model="isbind"
		size="small"
		> 
		<div id="mfbindfr">
			<el-steps :space="310" :active="active" finish-status="success">
				<el-step :title="$t('app_ckidt')"></el-step>
				<el-step :title="$t('app_istapp')"></el-step>
				<el-step :title="$t('app_bindmfa')"></el-step>
			</el-steps>
			<div id="mfbind1" v-if="active==0">
				<h5>{{$t('app_bindsfdv')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('lin_global.user')}}<label>{{brow.nickName}}</label>&nbsp;{{$t('app_psfwtsstepop')}}</h5>
				<el-input type="password" :placeholder="$t('app_ipaclgpsw')" v-model="mfafm.psw"></el-input>
			</div>
			<div id="mfbind2" v-if="active==1">
				<h5>{{$t('app_bindsfdv')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('lin_global.user')}}<label>{{brow.nickName}}</label>&nbsp;{{$t('app_psfwtsstepop')}}</h5>
				<h4>{{$t('app_phdnalyappggidck')}}</h4>
				<h3>{{$t('app_ipappstsagidck')}}</h3>
				<h3>{{$t('app_adappmksagidck')}}</h3>
				<h4>{{$t('app_afistclnxitbpagiinx')}}</h4>
			</div>
			<div id="mfbind3" v-if="active==2">
				<h5>{{$t('app_bindsfdv')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('lin_global.user')}}<label>{{brow.nickName}}</label>{{$t('app_psfwtsstepop')}}</h5>
				<h4>{{$t('app_usalyagidckscqrc6code')}}</h4>
				<div id="mfaqrcode" ref="mfaqrcode" ></div>
				<el-input :placeholder="$t('app_sixnumb')" v-model="mfafm.code"></el-input>
			</div>
		</div>
		<div slot="footer" class="dialog-footer" v-loading="dld">
			<el-button type="" v-if="active>0" @click="stepClick(0)">{{$t('app_lsstep')}}</el-button>
			<el-button type="" v-if="active<2" @click="stepClick(1)">{{$t('app_nxstep')}}</el-button>
			<el-button type="primary" v-if="active==2"  @click="bindRqs">{{$t('lin_btn.bind')}}</el-button>
		</div>
		</el-dialog>

		<el-dialog
		cclass="gDia"
		v-loading="logining"
		@close="closeUnbind"
		:title="$t('lin_btn.unbind')"
		v-model="isunbind"
		size="small"
		> 
		<div id="mfunbindfr">
			<h5>{{$t('app_sftkck')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('app_ip6codeubac')}}&nbsp;<label>{{brow.nickName}}</label></h5>
			<h4>{{$t('app_plipopenalyappoggidckip6dycd')}}</h4>
			<el-input :placeholder="$t('app_sixnumb')" v-model="mfafm.code"></el-input>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="unbindOpe">{{$t('app_sure')}}</el-button>
		</div>
		</el-dialog>
  </div>
</div>
</template>

<style>
	/* #mfbindfr {
		border:1px solid red;
	} */
	#mfbind1,#mfbind2,#mfbind3 {
		overflow: hidden;
		padding-top: 15px;
		box-sizing: border-box;
	}
	#mfbind1 .el-input {
		margin-top: 20px;
	}
	#mfbind1 h5,#mfbind2 h5, #mfbind3 h5 {
		padding-bottom: 5px;
		border-bottom: 1px solid lightgrey;
	}
	#mfbind1 h5 label,#mfbind2 h5 label, #mfbind3 h5 label {
		color: orange;
	}
	#mfaqrcode {
		margin-top: 15px;
	}
	#mfbind2 h4, #mfbind3 h4 {
		margin-top: 20px;
		font-weight: bold;
		font-size: 15px;
	}
	#mfbind2 h3, #mfbind3 h3 {
		margin-top: 10px;
	}
	#mfbind3 .el-input {
		margin-top: 20px;
	}
	#mfunbindfr h5 {
		padding-bottom: 5px;
		border-bottom: 1px solid lightgrey;
	}
	#mfunbindfr h5 label {
		color: orange;
	}
	#mfunbindfr h4 {
		margin: 20px 0 20px 0;
	}
</style>

<script>
  import axios from 'axios'
  import { baseurl,focusEvent } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import QRCode from 'qrcodejs2'
  var md5 = require('md5')

  export default{
    components: {
      MechanismSelector
	},
	props: {
		tmcid:String
	},
	name:'info',
	data () {
		var that = this
		return {
			dld: false,
			mfafm: {psw:'',code:''},
			qrres: '',
			brow: '',
			active: 0,
			isbind: false,
			isunbind:false,
			orderType: '',
			orderName: '',
			mechanismData: {
			placeholder: that.$t('lin_global.place_areaid'),
			callback (value) {
				that.value2 = value
				that.statusChange(value)
			}
			},
			focusEvent: focusEvent,
					loading: true,
					currentPage: 1,
					pageSize: 10,
					totalRecords: 0,
					arrdata:[],
			roleId:'',
			nickName:'',
			roleList:[],
			value2:'',
			areaList1: [],
			}
		},
		created(){ 
			
		},
		mounted () { 
			var _this = this
			setTimeout(() => {
				_this.getData(1,'','','');
				_this.getRole();
				_this.getAd1()
			}, 2000);
		},
		methods:{
			closeUnbind () {
				this.isunbind=false
				this.mfafm.code = ''
			},
			bindRqs () {
				if (!this.mfafm.code) {
					this.$message.error(this.$t('app_inputNumber'))
					return
				}
				this.dld=true
				this.$mfaBind(this.brow.userid, this.mfafm.code, res => {
					this.dld=false
					if (res.status==200) {
						this.closeBind()
						var _this = this
						setTimeout(() => {
							_this.getData(1,'','','');
							_this.getRole();
							_this.getAd1()
						}, 2000);
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.dld=false
				})
			},
			closeBind () {
				this.isbind=false
				this.dld=false
				this.mfafm={psw:'',code:''}
			},
			bindOpen () {
				this.$mfaQrcode(this.brow.userid, res => {
					this.qrres = res.data?res.data.qrCode:''
				}, '')
			},
			bindRow (row) {
				this.brow = row
				this.isbind=true
			},
			unbindRow (row) {
				this.brow = row
				this.isunbind=true
			},
			unbindOpe () {
				if (!this.mfafm.code) {
					this.$message.error(this.$t('app_inputNumber'))
					return
				}
				this.dld=true
				this.$mfaUnbind(this.brow.userid, this.mfafm.code, res => {
					this.dld=false
					if (res.status==200) {
						this.closeUnbind()
						var _this = this
						setTimeout(() => {
							_this.getData(1,'','','');
							_this.getRole();
							_this.getAd1()
						}, 2000);
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.dld=false
				})
			},
			createQrcode () {
				new QRCode('mfaqrcode', {
				width:150,
				height: 150, // 高度
				text: this.qrres // 二维码内容
				// render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
				// background: '#f0f'
				// foreground: '#ff0'
				})
			},
			nextOpe (isnext) {
				if (isnext) {
					this.active=this.active+1>2?this.active:this.active+1
				} else {
					this.active=this.active-1==-1?this.active:this.active-1
				}
			},
			stepClick (isnext) {
				if (this.active==0) {
					if (!this.mfafm.psw) {
						this.$message.error(this.$t('lin_global.plePassTips'))
						return
					} else {
						//checkid
						this.dld=true
						this.$mfaIdCheck(this.brow.userid, md5(this.mfafm.psw), res => {
							this.dld=false
							if (res.status==200) {
								this.nextOpe(isnext)
							} else {
								this.$message.error(res.message)
							}
						}, '')
					}
				} else if (this.active==1) {
					this.nextOpe(isnext)
				} else if (this.active==2) {
					this.nextOpe(isnext)
				}
				
				switch (this.active) {
					case 2:
						this.$nextTick(() => {
							this.createQrcode()
						})
						break;
				}
			},
			sortChange (vl) {
        switch (vl.prop) {
          case 'userName':
            this.orderName = '1'
            break
          case 'nickName':
            this.orderName = '2'
            break
          case 'createTime':
            this.orderName = '3'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getData(this.currentPage,this.roleId,this.nickName,this.value2)
      },
      getAd1:function(){
        var params = {page:1,rows:10000};
        axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
          console.log(res.data);
          var obj={
            'mechanismname':this.$t('lin_global.all_mechanism'),
            'mechanismid':''
          }
          this.areaList1 = res.data.data;

          this.areaList1.unshift(obj)
        })
      },
      statusChange(){
        this.getData(this.currentPage,this.roleId,this.nickName,this.value2)
      },
      getRole:function(){
        var mechanismId = localStorage.getItem('mechanismId');
        var params = {page:1,rows:10000,distributorid:mechanismId};
        axios.post(`${baseurl}/role/list.do`,params).then(res=>{
          this.roleList = res.data.data;
        })
      },
      roleChange(){
        this.getData(1,this.roleId,this.nickName,this.value2)
      },
      handleIconClick(){
        this.getData(1,this.roleId,this.nickName,this.value2)
      },
			handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getData(this.currentPage,this.roleId,this.nickName,this.value2)
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getData(this.currentPage,this.roleId,this.nickName,this.value2)
		    },
			formatStatus:function(row,column){
		      return row.userStatus == 0?this.$t('lin_global.jh'):row.userStatus == 1?this.$t('lin_global.dj'):'';
		    },
			onCancel:function(){

			},
			add:function(){
				if (this.tmcid) {
					this.$setWObj('tmcid', this.tmcid)
        	this.$router.push({path: '/channels/channel-detail/addaccount'})
				} else {
					this.$setWObj('tmcid', '')
					this.$router.push({ path: '/accMess/add' })
				}
				
			},
			editRow:function(userid){
		
				this.$router.push({ path: '/accMess/'+userid+'/add' })
			},
			deleteRow:function(userid){
				var params = {'userid':userid};
				this.$confirm(this.$t('account.delete_tips'),this.$t('lin_btn.tips'),{
					confirmButtonText: this.$t('lin_btn.confirm'),
          			cancelButtonText: this.$t('lin_btn.cancel'),
          			type: 'warning'
				}).then(()=>{
					axios.post(`${baseurl}/user/delete.do`,params).then(res=>{
					    console.log("hhh");
					    console.log(res.data)
						if (res.data.status == 200) {
          this.getData(this.currentPage,this.roleId,this.nickName,this.value2)
			              this.$message.success(this.$t('lin_global.delete_success'));
			            } else {
          this.$message.error(res.data.message)
			            }
					})
				}).catch(() => {

        		})

			},
			getData:function(page,a,b,c){
				this.currentPage = page;
				let userid = localStorage.getItem('userId');

				var tmpmc = this.tmcid?this.tmcid:''

				var params = {orderType: this.orderType, orderName: this.orderName,"page":page,"rows":this.pageSize,"nickName":b,"phone":"","status":"","userId":userid,"roleId":a,"distributorId":tmpmc?tmpmc:c}
				axios.post(`${baseurl}/user/sub_account.do`,params).then(res=>{
				    if(res.data.status == 200){
              this.arrdata = res.data.data;
              this.totalRecords = res.data.total;
              this.loading = false;
            }else{
              this.$message.error(res.data.message)
            }

		        })
			}
		}
	}
</script>



// WEBPACK FOOTER //
// accMess.vue?baee97c2